import { Component, h, Prop } from '@stencil/core';
import logout from '../../services/logout';
import fetchUserProfile from '../../services/fetchUserProfile';
@Component({
  tag: 'header-nav',
  styleUrl: 'header-nav.scss',
  shadow: true,
})
export class headerNav {
  /**
   * The dev env
   */
  urls="red"
  @Prop() env?: string = 'https://www.brighttalk.com';

  // This will add a redirect param to the end of the login url
  @Prop() loginRedirect?: string = '/login';

  // User State
  @Prop() isLoggedIn: boolean = false;
  @Prop() isManager: boolean = false;
  @Prop() isChannelOwner: boolean = false;
  @Prop() isPreAuthenticated: boolean = false;

  // Show/Hide Elements
  @Prop() join?: boolean = true;


  async setCookie(name,val) {
    const date = new Date();
    const value = val;

    // Set it expire in 7 days
    date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));

    // Set it
    document.cookie = name+"="+value+"; expires="+date.toUTCString()+"; path=/";
  }
  async delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  async setTimeZone(){
    const user=await fetchUserProfile(this.env);
    if(user){
      this.setCookie('BT_USER_TIMEZONE',user.timeZone);
    }
  }

  async logoutBtn(e) {
    e.preventDefault();
    this.delete_cookie('BT_USER_TIMEZONE');
	this.delete_cookie('PREAUTH');
	this.delete_cookie('PREAUTHBTSESSION');
	await logout(this.env);
  }


  myAccount() {
    return (
      <ul id="menu-header" class="btalk-nav">
        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/all-talks`}>Watch <span class="fa-solid fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
            <li>
              <a class="menu-item" href={this.env +`/all-talks`}>
                Talks
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/summits`}>
                Summits
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/series`}>
                Series
              </a>
            </li>
          </ul>
        </li>

        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/topics`}>Browse <span class="fa-solid fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
            <li>
              <a class="menu-item" href={this.env +`/topics/most-popular`}>
                Topics
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/channels`}>
                Channels
              </a>
            </li>
          </ul>
        </li>

        <li class="my-account menu-item menu-item-has-children">
          <a href="#" rel="nofollow">
            <span>My account </span>
            <span class="icon far fa-angle-down" aria-hidden="true"></span>
          </a>
          <ul class="sub-menu">
            {this.isManager ? (
              <li class="menu-item">
                <a class="menu-item" href={this.env + `/central/manage/channels/`}>
                  Manage
                </a>
              </li>
            ) : (
              ''
            )}
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/my-feed`}>
                My feed
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/watch-later`}>
                Watch later
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/recently-viewed`}>
                Recently viewed
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/channels`}>
                My channels
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/settings/profile/`}>
                Account settings
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item"  href="/logout" onClick={e => this.logoutBtn(e)}>
                Log out
              </a>
            </li>
          </ul>
        </li>
      </ul>
    );
  }

  loginJoin() {
    return (
      <ul id="menu-header" class="btalk-nav">
        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/all-talks`}>Watch <span class="fa-solid fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
            <li>
              <a class="menu-item" href={this.env +`/all-talks`}>
                Talks
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/summits`}>
                Summits
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/series`}>
                Series
              </a>
            </li>
          </ul>
        </li>

        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/topics`}>Browse <span class="fa-solid fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
          <li>
            <a class="menu-item" href={this.env +`/topics/most-popular`}>
              Topics
            </a>
          </li>
          <li>
            <a class="menu-item" href={this.env +`/channels`}>
              Channels
            </a>
          </li>
          </ul>
        </li>

        <li class="menu-item">
          <a class="" href={this.env + this.loginRedirect} rel="nofollow">
            Log in
          </a>
        </li>
		{this.join ? <li class="menu-item btl-out btl-join btalk-join">
          <a class="" href={this.env + `/join`}>
            <span>Join now</span>
          </a>
        </li> : ''}
      </ul>
    );
  }

  render() {
    this.isLoggedIn ?this.setTimeZone():'';
    return <nav class="btalk-nav-wrap desktop">{this.isLoggedIn ? this.myAccount() : this.loginJoin()}</nav>;
  }
}
